/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import classnames from "classnames";
import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Col, Row } from "reactstrap";
import { HelpTextComponent } from "./components";
import "./styles.scss";

Object.byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

export const InputContainer = ({ children, name, label, subLabel }) => {
  const { formState, errors } = useFormContext();
  let hasError = Object.byString(errors, name) !== undefined;
  let className = "full-input-2";
  let showCheck = false;
  if (formState.dirtyFields[name]) {
    if (!hasError) {
      showCheck = true;
      className = "full-input-2-active";
    } else {
      showCheck = false;
      className = "full-input-2";
    }
  }

  return (
    <React.Fragment>
      <div className='form-contenedor-type1'>
        <div className={className}>
          <label className={"label-full-input"}>
            {label}
            {showCheck && <div className={"img-input-active "}>&nbsp;</div>}
          </label>
          <Row>
            <Col lg={10} md={10} sm={10} xs={10}>
              {children}
            </Col>
            <Col lg={2} md={2} sm={2} xs={2}>
              <div className='placeholder-full-input-type1 mt-2'>{subLabel}</div>
            </Col>
          </Row>
          {Object.byString(errors, name) && (
            <strong className='error-msg-input'>{errors[name].message}</strong>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export const InputDiasContainer = ({ children, label, subLabel, name }) => {
  const { formState, errors } = useFormContext();
  let hasError = errors[name] !== undefined;
  let className = "full-input-2";
  let showCheck = false;

  if (formState.dirtyFields[name]) {
    if (!hasError) {
      showCheck = true;
      className = "full-input-2-active";
    } else {
      showCheck = false;
      className = "full-input-2";
    }
  }

  return (
    <React.Fragment>
      <div className='form-contenedor-type1'>
        <div className={className}>
          <label className={"label-full-input"}>
            {label}
            {showCheck && <div className='img-input-active '>&nbsp;</div>}
          </label>
          <Row>
            <Col lg={10} md={10} sm={10} xs={10}>
              {children}
            </Col>
            {subLabel && (
              <Col lg={2} md={2} sm={2} xs={2}>
                <div className='placeholder-full-input-type1 mt-2'>{subLabel}</div>
              </Col>
            )}
          </Row>
          {errors[name] && (
            <strong className='error-msg-input'>{errors[name].message}</strong>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export const InputAccidentesContainer = ({
  children,
  label,
  subLabel = null,
  helpText,
  name,
}) => {
  const { formState, errors } = useFormContext();
  let hasError = Object.byString(errors, name) !== undefined;
  let showCheck = false;
  if (formState.dirtyFields[name]) {
    showCheck = !hasError;
  }
  return (
    <React.Fragment>
      <div className='container-accidentes'>
        {label && (
          <label className='accidentes text-left text-uppercase' htmlFor={name}>
            {label}
            {showCheck && <div className='img-input-active '>&nbsp;</div>}
          </label>
        )}

        <div className='container-input-accidentes' style={{ minHeight: "3rem" }}>
          <div className='row'>
            <div
              className={classnames({
                "col-10": subLabel !== null,
                "col-12": !subLabel,
                "mt-2": true,
              })}>
              {children}
            </div>
            {subLabel && (
              <div className='col-2 mt-2'>
                <div className='placeholder-full-input-type1 mt-2'>{subLabel}</div>
              </div>
            )}
          </div>
          {helpText && <div className='help-text-input'>{helpText}</div>}
          {Object.byString(errors, name) && (
            <strong className='error-msg-input'>
              {Object.byString(errors, name).message}
            </strong>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export const SimpleWrapper = ({
  children,
  label,
  subLabel = null,
  name,
  leyenda = null,
  extrasClasses,
  showOk = true,
  helpText = null
}) => {
  const { formState, errors } = useFormContext();
  let hasError = Object.byString(errors, name) !== undefined;
  let showCheck = false;
  if (formState.dirtyFields[name]) {
    showCheck = !hasError;
  }
  return (
    <React.Fragment>
      <div className={"container-accidentes w-100 " + extrasClasses}>
        <div className="col-12 m-0 p-0 d-flex flex-wrap">
          <label
            className='accidentes text-left'
            htmlFor={name}
            style={{ fontSize: "20px" }}>
            {label}
            {showCheck && showOk && <div className='img-input-active '>&nbsp;</div>}
          </label>
          {leyenda && <p className='text-muted mx-4 mt-1'>{leyenda}</p>}
        </div>
        <div className='container-input-accidentes'>
          <div className='row'>
            <div
              className={classnames({
                "my-2": true,
                "col-10": subLabel !== null,
                "col-12": !subLabel,
              })}>
              {children}
              {helpText && (
                <div
                  className='d-flex flex-row justify-content-center'
                  style={{ margin: "0 0 0 0" }}>
                  <HelpTextComponent width='95%'>{helpText}</HelpTextComponent>
                </div>
              )}
            </div>
            {subLabel && (
              <div className='col-2 mt-2'>
                <div className='placeholder-full-input-type1 mt-2 mb-2'>{subLabel}</div>
              </div>
            )}

          </div>
          {Object.byString(errors, name) && (
            <strong className='error-msg-input'>
              {Object.byString(errors, name).message}
            </strong>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export const SimpleWrapperRCP = ({
  children,
  label,
  subLabel = null,
  name,
  info = null,
  extrasClasses,
}) => {
  const { formState, errors } = useFormContext();
  let hasError = Object.byString(errors, name) !== undefined;
  let showCheck = false;
  if (formState.dirtyFields[name]) {
    showCheck = !hasError;
  }
  return (
    <React.Fragment>
      <div className={"container-accidentes w-100" + extrasClasses}>
        <label
          className='accidentes text-left'
          htmlFor={name}
          style={{ fontSize: "20px" }}>
          {label} {showCheck && <div className='img-input-active '>&nbsp;</div>}
          {info !== null && (
            <Button
              type='button'
              style={{ borderRadius: "25%" }}
              className='p-button-text p-button-plain p-0 pl-1 font-20px'
              tooltip={info ?? ""}>
              <i className='pi pi-question-circle' style={{ fontSize: "1rem" }} />
            </Button>
          )}
        </label>
        <div className='container-input-accidentes'>
          <div className='row'>
            <div
              className={classnames({
                "my-2": true,
                "col-10": subLabel !== null,
                "col-12": !subLabel,
              })}>
              {children}
            </div>
            {subLabel && (
              <div className='col-2 mt-2'>
                <div className='placeholder-full-input-type1 mt-2 mb-2'>{subLabel}</div>
              </div>
            )}
          </div>
          {Object.byString(errors, name) && (
            <div className='container col-12'>
              <strong className='error-msg-lf '>
                {Object.byString(errors, name).message}
              </strong>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export const InputButtonLabelContainer = ({
  children,
  label,
  subLabel,
  name,
  helpText,
  extrasClasses,
  initialShowInput = false,
  onClickShow,
  btnName = `show${name}`,
}) => {
  const { errors, register, unregister, setValue, watch } = useFormContext();

  const [showInput, setShowInput] = useState(initialShowInput);

  const onInit = async () => {
    register(btnName, null);
    const btnNameValue = watch(btnName);
    setValue(btnName, btnNameValue || false);
    setShowInput(btnNameValue || false);
  };

  useEffect(() => {
    onInit();
    return () => {
      unregister(btnName);
    };
  }, []);

  const onClickBtn = (show) => (event) => {
    event.preventDefault();
    setShowInput(show);
    onClickShow && onClickShow(show);
    setValue(btnName, show);
  };

  return (
    <React.Fragment>
      <div className='container-accidentes'>
        <label className='accidentes text-left' htmlFor={name}>
          {label}
          <button
            className={`in-label ${showInput && "selected"}`}
            onClick={onClickBtn(true)}>
            SI
          </button>
          <button
            className={`in-label ${!showInput && "selected"}`}
            onClick={onClickBtn(false)}>
            NO
          </button>
        </label>

        {showInput && (
          <React.Fragment>
            <div className='container-input-accidentes'>
              <div className='row'>
                <div
                  className={classnames({
                    "my-2": true,
                    "col-10": subLabel,
                    "col-12": !subLabel,
                  })}>
                  {children}
                </div>
                {subLabel && (
                  <div className='col-2 mt-2'>
                    <div className='placeholder-full-input-type1 mt-2'>{subLabel}</div>
                  </div>
                )}
              </div>
              {Object.byString(errors, name) && (
                <strong className='error-msg-input'>
                  {Object.byString(errors, name).message}
                </strong>
              )}
            </div>

            {helpText && <small className='help-text'>{helpText}</small>}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
